import React, { useState } from 'react';
import { Portal } from 'react-portal';
import loadable from '@loadable/component';
import { AboutUsContent, TextWrapper, Title, SubTitle, ButtonWrapper } from './styles';
import { Container } from '../../../components/Layout/styles';
import Button from '../../../components/Button2.0';
import { MessageImg } from '../images';
import { PopupContentWrapper, Section } from '../styles';

const Modal = loadable(() => import('../../../components/Modal/Modal'), { fallback: null, ssr: false });
const CallbackPopup = loadable(() => import('../../../components/CallbackModalForm'), {
	fallback: null,
	ssr: false,
});

const AboutUs = () => {
	const [showCallback, setShowCallback] = useState(false);

	return (
		<Section id="SectionAbout" type="about">
			<Container>
				<AboutUsContent>
					<img src={MessageImg} alt="О нас" />
					<TextWrapper>
						<Title>Рассказать о наших услугах?</Title>
						<SubTitle>
							Оставьте свои контактные данные, мы перезвоним в течение часа и ответим на все вопросы
						</SubTitle>
					</TextWrapper>

					<ButtonWrapper>
						<Button style={{ width: '100%' }} onClick={() => setShowCallback(true)}>
							Заказать звонок
						</Button>
					</ButtonWrapper>
				</AboutUsContent>
			</Container>
			<Portal>
				<Modal isShowing={showCallback} hide={() => setShowCallback(false)}>
					<PopupContentWrapper>
						<CallbackPopup callbackType="callback" />
					</PopupContentWrapper>
				</Modal>
			</Portal>
		</Section>
	);
};
export default AboutUs;
